module.exports = __webpack_public_path__ + "static/media/gamesWon_10000_25000.1c4e1bfc.png";